module.exports = __webpack_public_path__ + "media/images/top/wedding_ceremony_cost-0646601579cd2a75139d51936b8d52e8.png";